<app-modal #modal class="create-expense-modal">
  <div class="modal-header">
    <h2 class="modal-title">Edit Expense</h2>
  </div>
  <div class="modal-body">
    <form (submit)="onFormSubmit()" [formGroup]="form">

      <div class="simple-form">
        <div class="form-row">
          <div class="form-label"><label>Trial</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-trial-autocomplete #trialAutocomplete [form]="form" controlName="trialId"
                (valueChanged)="onTrialChanged($event)" placeholder="Select a trial..."></app-trial-autocomplete>
            </div>
          </div>
        </div>
        <div class="form-row" [class.has-non-visits]="hasNonVisits">
          <div class="form-label"><label>{{ showNonVisits ? 'Non-visit' : 'Visit' }}</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-dropdown-input #visitSelect (selectValueChanged)="onSelectChanged('visitId', $event)"
                [options]="visitOptions" [parentForm]="form" name="visitId" [filterable]="true" [truncate]="true"
                [placeholder]="showNonVisits ? 'Select Non-visit...' : 'Select Visit...'"></app-dropdown-input>

              @if (hasNonVisits) {
              <div class="visit-row-actions">
                @if (hasNonVisits) {
                <a class="toggle-non-visits" (click)="toggleNonVisits()">{{ showNonVisits ? 'Show Visits' : 'Show Non-visits' }}</a>
                }
              </div>
              }
            </div>

            @if (expenseClaimDetails && !expenseClaimDetails.isNonVisit && !expenseClaimDetails.isDailySpendVisit &&
            expenseClaimDetails.trialDailySpendExpensesEnabled) {
            <div class="move-to-none-visit">
              <div class="move-to-none-visit-label">
                <span class="non-visit-label">Assign to this day's non-visit visit</span>

                @if (expenseClaimDetails?.trialDailySpendExpensesEnabled && expenseClaimDetails?.receipts?.length > 0) {
                <app-expense-ai-receipt-date [receipts]="expenseClaimDetails.receipts"
                  size="sm"></app-expense-ai-receipt-date>
                }
              </div>
              <div class="move-to-none-visit-form">
                <input class="form-control" formControlName="nonVisitDate" type="date" />

                <app-button text="Assign & Save" size="sm" variant="info"
                  [disabled]="!form.get('nonVisitDate').value || !form.get('nonVisitDate').valid"
                  [isBusy]="isFormProcessing" (clicked)="confirmAssignToNonVisit()" />
              </div>
            </div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"><label>Payment Method</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-dropdown-input #paymentMethodSelect (selectValueChanged)="onSelectChanged('paymentMethod', $event)"
                [options]="paymentMethodOptions" [parentForm]="form" name="paymentMethod"
                placeholder="Select Payment Method..."></app-dropdown-input>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"><label>Expense Category</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-dropdown-input #categorySelect (selectValueChanged)="onSelectChanged('categoryId', $event)"
                [options]="categoryOptions" [parentForm]="form" name="categoryId"
                placeholder="Select Category..."></app-dropdown-input>
            </div>
          </div>
        </div>
        <div class="form-row"
          *ngIf="expenseClaimDetails !== undefined && expenseClaimDetails.subCategories !== undefined"
          [ngClass]="{'visibility-hidden': selectedCategory === null || selectedCategory.internalType.toLowerCase() !== 'other'}">
          <div class="form-label"></div>
          <div class="form-field">
            <div class="radio-button-container">
              @for (subCategory of expenseClaimDetails.subCategories; track subCategory.id) {
              @if (subCategory.id !== 6 || form.get('subCategoryId').value === 6) {
              <div class="form-group">
                <label class="radio-button">
                  <input [value]="subCategory.id" formControlName="subCategoryId" type="radio" />
                  <span></span>
                  {{ subCategory.name }}
                </label>
              </div>
              }
              }
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label valign-top"><label>Currency</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-autosuggest-dropdown-input #currencySelect (selectValueChanged)="onSelectChanged('currency', $event)"
                [options]="currencyOptions" [parentForm]="form" controlName="currency"
                placeholder="Select Currency..."></app-autosuggest-dropdown-input>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label valign-top"><label>Amount</label></div>
          <div class="form-field">
            <div class="form-group amount-container">
              <input class="form-control" formControlName="amount" type="number" (wheel)="disableScrollWheel($event)"
                (keydown)="numberHelper.decimalFilter($event)">
              <span *ngIf="form.controls.subCategoryId.value === ExpenseSubCategory.CardPreloadRedemption">-</span>
            </div>
          </div>
        </div>
        <div class="form-row" [ngClass]="{'visibility-hidden': !showTransformedCurrency}">
          <div class="form-label valign-top"><label>&nbsp;</label></div>
          <div class="form-field" style="padding-bottom: 20px;">
            <app-button text="FX" type="button" [isBusy]="transformedCurrencyProcessing" width="fill"
              (clicked)="onShowTransformedFxRate()" />
          </div>
        </div>
        <div class="form-row" *ngIf="showFxTransformError && !canTransformRate"
          [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
          <div class="form-label valign-top"><label>&nbsp;</label></div>
          <div class="form-field">
            <div class="col-12 col-lg-12 quoted-amount-error-message-wrapper">
              <span class="quoted-amount-error-message">
                The quoted amount, currency and the base currency on connected
                trial cannot be blank.
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label valign-top"><label>Amount Quoted (BC)</label></div>
          <div class="form-field">
            <div class="form-group amount-container">
              <app-input-currency #amountQuotedBCControl [parentForm]="transformedFxRateForm" placeholder="0.00"
                amountControlName="transformedAmount" currencyControlName="transformedCurrency">
              </app-input-currency>
              <span *ngIf="form.controls.subCategoryId.value === ExpenseSubCategory.CardPreloadRedemption">-</span>
            </div>
          </div>
        </div>
        <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Distance'}">
          <div class="form-label valign-top"><label>Distance Unit</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-dropdown-input #distanceUnitSelect (selectValueChanged)="onSelectChanged('distanceUnit', $event)"
                [options]="distanceUnitOptions" [parentForm]="form" name="distanceUnit"
                placeholder="Select Distance Unit..."></app-dropdown-input>
            </div>
          </div>
        </div>
        <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Distance'}">
          <div class="form-label valign-top"><label>Distance</label></div>
          <div class="form-field">
            <div class="form-group">
              <input class="form-control" formControlName="distanceAmount" type="number" step="1"
                (input)="onDistanceAmountInput($event)">
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label valign-top"><label>Expense Notes</label></div>
          <div class="form-field">
            <div class="form-group">
              <textarea class="form-control" formControlName="notes"></textarea>
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="trial?.imsLegacyTrial">
          <div class="form-label"><label>Claim Form Id</label></div>
          <div class="form-field">
            <div class="form-group">
              <input class="form-control" formControlName="claimFormId" type="text">
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="trial?.imsLegacyTrial">
          <div class="form-label"><label>Claim Form Date</label></div>
          <div class="form-field">
            <div class="form-group form-datepicker">
              <mat-form-field>
                <input matInput [matDatepicker]="picker" formControlName="claimFormDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="trial?.imsLegacyTrial">
          <div class="form-label"><label>Claim Form URL</label></div>
          <div class="form-field">
            <div class="form-group">
              <input class="form-control" formControlName="claimFormUrl" type="text">
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="expenseClaimDetails && expenseClaimDetails.state === 'Rejected'">
          <div class="form-label valign-top"><label>Rejection Reason</label></div>
          <div class="form-field">
            <div class="form-group">
              <textarea class="form-control" formControlName="rejectionReason"></textarea>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"><label>On Hold</label></div>
          <div class="form-field">
            <div class="form-group">
              <label class="checkbox">
                <input formControlName="onHold" type="checkbox">
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"><label>Sponsor Approved</label></div>
          <div class="form-field">
            <div class="form-group">
              <label class="checkbox">
                <input formControlName="overspendApproved" type="checkbox">
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"><label>Fully Reconciled</label></div>
          <div class="form-field">
            <div class="form-group">
              <label class="checkbox">
                <input formControlName="fullyReconciled" type="checkbox">
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label valign-top"><label>Reason for Edit <sup>*</sup></label></div>
          <div class="form-field">
            <div class="form-group">
              <textarea class="form-control" formControlName="reasonForEdit"></textarea>
              <span *ngIf="form.get('reasonForEdit').errors?.invalidCharacters" class="error-label">
                Reason for edit
                contains invalid characters: '|', '+'.
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"></div>
          <div class="form-field">
            <div class="btn-wrap">
              <div class="row">
                <div class="col-6">
                  <app-button text="Cancel" variant="secondary" width="fill" type="button" (clicked)="onCancelEditing()" />
                </div>
                <div class="col-6">
                  <app-button text="Save" type="submit" [isBusy]="isFormProcessing" [disabled]="!form.valid"
                    width="fill" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</app-modal>

<app-modal-v2 #recalculateAmountBcModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title text-center">Recalculate BC amount ?</h2>
    </div>
    <div class="modal-body text-center">
      <p>Expense claim amount or currency changed, do you want to recalculate amount in BC ?</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="No" variant="secondary" [isBusy]="isFormProcessing" width="fill"
            (clicked)="onFormSubmit(false)" />
        </div>

        <div class="col-6">
          <app-button text="Yes" [isBusy]="isFormProcessing" width="fill" (clicked)="onFormSubmit(true)" />
        </div>
      </div>
    </div>
  </div>
</app-modal-v2>

<app-confirm-action-modal #confirmNonVisitModal (confirmed)="assignToNonVisit()">
</app-confirm-action-modal>

<app-modal #preloadConfirmModal>
  <div class="modal-header"><h2 class="modal-title">Payment Method Override</h2></div>
  <div class="modal-body">
    <p>Preload expenses can only use Caxton Card as the payment method. The payment method will be set to Caxton Card. Do you want to proceed?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6"><button (click)="preloadConfirmModal.hide()" class="btn btn-secondary btn-full-span" type="button">Cancel</button></div>
      <div class="col-6"><button (click)="confirmPreloadCardOverride()" class="btn btn-primary btn-full-span" type="button">Proceed</button></div>
    </div>
  </div>
</app-modal>
